import { useEffect, useState } from "react";
import PackButtonsExport from "./pack/packButtonsExport";
import PaginationAvantsolar from "components/utils/paginationAvantSolar";
import SpinnerAvantsolar from "components/utils/spinner";

const DataTableProdPeriodo = ({
  data,
  dataCopy,
  setData,
  titleProps,
  headers, //Los nombres de las columnas que se van a imprimir en la tabla. //Los nombres de las columnas que se van a imprimir en los archivos de descarga.
  headersTable,
  name,
  properties,
  filtros,
  placeholderInput,
  defaultMostrar = 5,
  loading,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(defaultMostrar);

  const nPages = Math.ceil(data?.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  let currentRecordSlice = data?.slice(indexOfFirstRecord, indexOfLastRecord);
  const [currentRecords, setCurrentRecords] = useState(currentRecordSlice);

  useEffect(() => {
    let currentRecordSlice = data?.slice(indexOfFirstRecord, indexOfLastRecord);
    setCurrentRecords(currentRecordSlice);
  }, [data, currentPage, recordsPerPage]);

  useEffect(() => {
    const container = document.querySelector(".main-panel");
    container.scrollTop = 0;
  }, [currentRecords]);

  return (
    <div className="p-3 p-xl-5 w-100">
      {loading && <SpinnerAvantsolar></SpinnerAvantsolar>}
      <PackButtonsExport
        data={currentRecords}
        dataCopy={dataCopy}
        setData={setData}
        titleProps={titleProps}
        headers={headers}
        name={name}
        properties={properties}
        filtros={filtros}
        placeholderInput={placeholderInput}
        setCurrentPage={setCurrentPage}
      ></PackButtonsExport>

      <table className=" mt-3 table-responsive-xs  w-100 tablaListado ">
        <tbody>
          {currentRecords?.map((inversor, i) => {
            let totalValorInicial = 0;
            let totalValorFinal = 0;
            return (
              <>
                {inversor?.datos?.map((dato) => {
                  totalValorInicial += dato.valorInicial;
                  totalValorFinal += dato.valorFinal;
                  let datoFinal = 0;
                  if (dato.valorInicial >= dato.valorFinal) {
                    datoFinal = dato.valorInicial - dato.valorFinal;
                  } else {
                    datoFinal = dato.valorFinal - dato.valorInicial;
                  }
                  return (
                    <tr>
                      <td> {inversor.nombreInstalacion}</td>
                      <td>{inversor.titular}</td>
                      <td> {dato.nombre}</td>
                      <td>
                        ({dato.fechaInicial}){dato.valorInicial}
                        {"-"}
                        {dato.valorFinal}({dato.fechaFinal})
                      </td>
                      <td>{dato.valorFinal} KWh</td>
                    </tr>
                  );
                })}
                <tr className="TablaBottom ">
                  <td colSpan={2}>Parámetro diario: {inversor.paramDiario}</td>
                  <td>Pot pico: {inversor.potPico}</td>
                  <td>
                    {totalValorInicial}-{totalValorFinal}
                  </td>
                  <td className="borderTabla text-center">
                    {inversor.totalInstalacion} KWh
                  </td>
                </tr>
              </>
            );
          })}
        </tbody>
      </table>

      <PaginationAvantsolar
        data={data}
        nPages={nPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setRecordsPerPage={setRecordsPerPage}
        recordsPerPage={recordsPerPage}
      ></PaginationAvantsolar>
    </div>
  );
};

export default DataTableProdPeriodo;
